module.exports = __webpack_public_path__ + "static/media/LISTADESEOS_azul.12a034c4.svg";